import { GlButton, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'WorkItemDisplaySettingsButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        selected: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'click'
    ]
};
